// // window.addEventListener("DOMContentLoaded", (event) => {
//   var start_url = window.location.href;
//   var click_for_loc_chng = [...document.querySelectorAll('.ib-prod-variant input')];
//   var backorder_div = [...document.querySelectorAll('.ibat-backorder')][0];
//   var addtocart_div = [...document.querySelectorAll('.add-to-cart-wrapper')][0];
//   /*  ------ For First Load Backorder ----- */
//   var urlString = window.location.search;
//   var path_for_api_fetch = window.location.pathname;
//   var selection_div_for_padd = [...document.querySelectorAll('.ibat-your-selection')][0];
//   var without_last_slash_for_api = path_for_api_fetch.endsWith("/") ? path_for_api_fetch.slice(0, -1) : path_for_api_fetch;
//   var apiUrl = `${without_last_slash_for_api}.js`;
//       fetch(apiUrl)
//       .then(response => response.json())
//       .then(data => {
//         // Replace with  Package Protection and warranty Product id
//         if(!backorder_div &&  data.id != '7314112905304' &&  data.id != '7311853027416' &&  data.id != '4492776833112'){
//           if(urlString.length == 0){
//             if(data.variants[0].inventory_quantity <= 0){
//               addtocart_div.insertAdjacentHTML('beforebegin','<div class="ibat-backorder"><span>Backorder: Ships Once In Stock</span></div>');
//               if(selection_div_for_padd.classList.contains('ibat-without-backorder')){
//                 selection_div_for_padd.classList.remove('ibat-without-backorder');               
//               }
//             } 
//             else if(data.variants[0].inventory_quantity <= 4 && data.variants[0].inventory_quantity >= 1){
//               addtocart_div.insertAdjacentHTML('beforebegin','<div class="ibat-backorder"><span>Less than 4 In Stock</span></div>');
//               if(selection_div_for_padd.classList.contains('ibat-without-backorder')){
//                 selection_div_for_padd.classList.remove('ibat-without-backorder');
//               }
//             }
//           }
//           else if(urlString.startsWith("?variant=")){
//             var variant_url_id = new URLSearchParams(urlString).get("variant");
//             data.variants.forEach(variant => {
//               if(variant.id == variant_url_id){
//                 if(variant.inventory_quantity <= 0){
//                   addtocart_div.insertAdjacentHTML('beforebegin','<div class="ibat-backorder"><span>Backorder: Ships Once In Stock</span></div>');
//                   if(selection_div_for_padd.classList.contains('ibat-without-backorder')){
//                     selection_div_for_padd.classList.remove('ibat-without-backorder');
//                     ib_backorder.innerText = 'backorder';
//                   }
//                 }
//                 else if(variant.inventory_quantity <= 4 && variant.inventory_quantity >= 1){
//                   addtocart_div.insertAdjacentHTML('beforebegin','<div class="ibat-backorder"><span>Less than 4 In Stock</span></div>');
//                   if(selection_div_for_padd.classList.contains('ibat-without-backorder')){
//                     selection_div_for_padd.classList.remove('ibat-without-backorder');
//                   }
//                 }
//               }
//             });
//           }
//         }
        
//       })
//       .catch(error => {
//         console.error("Error fetching product details:", error);
//       });
//   /*  ------ End First Load Backorder ----- */
//   click_for_loc_chng.forEach(input_click => {
//     input_click.addEventListener("click", function(e){
//       setTimeout(function(){
//         var change_url = window.location.href;
//         if(change_url != start_url){
//           var urlString_changed = window.location.search;
//           var path_for_api_fetch_var_change = window.location.pathname;
//           var without_last_slash_for_api_var_change = path_for_api_fetch_var_change.endsWith("/") ? path_for_api_fetch_var_change.slice(0, -1) : path_for_api_fetch_var_change;
//           var apiUrl_change = `${without_last_slash_for_api_var_change}.js`;
//           fetch(apiUrl_change)
//           .then(response => response.json())
//           .then(data => {
//               if(urlString_changed.startsWith("?variant=")){
//                 var variant_url_id = new URLSearchParams(urlString_changed).get("variant");
//                 data.variants.forEach(variant => {
//                   // Replace with  Package Protection and warranty Product id
//                   if(variant.id == variant_url_id && data.id != '7314112905304' &&  data.id != '7311853027416' &&  data.id != '4492776833112'){
//                     var backorder_div_variant_change = [...document.querySelectorAll('.ibat-backorder')][0];
//                     var selection_div_for_padd_change = [...document.querySelectorAll('.ibat-your-selection')][0];
//                     if(variant.inventory_quantity <= 0){
//                       if(!backorder_div_variant_change){
//                         addtocart_div.insertAdjacentHTML('beforebegin','<div class="ibat-backorder"><span>Backorder: Ships Once In Stock</span></div>');
//                         if(selection_div_for_padd_change.classList.contains('ibat-without-backorder')){
//                           selection_div_for_padd_change.classList.remove('ibat-without-backorder');
//                         }
//                       }
//                       else if(backorder_div_variant_change.innerText.toLowerCase() != "backorder: ships once in stock"){
//                         backorder_div_variant_change.remove();
//                         addtocart_div.insertAdjacentHTML('beforebegin','<div class="ibat-backorder"><span>Backorder: Ships Once In Stock</span></div>');
//                         if(selection_div_for_padd_change.classList.contains('ibat-without-backorder')){
//                           selection_div_for_padd_change.classList.remove('ibat-without-backorder');
//                         }
//                       }
//                     } 
//                     else if(variant.inventory_quantity <= 4 && variant.inventory_quantity >= 1){
//                       if(!backorder_div_variant_change){
//                         addtocart_div.insertAdjacentHTML('beforebegin','<div class="ibat-backorder"><span>Less than 4 In Stock</span></div>');
//                         if(selection_div_for_padd_change.classList.contains('ibat-without-backorder')){
//                           selection_div_for_padd_change.classList.remove('ibat-without-backorder');
//                         }
//                       }
//                       else if(backorder_div_variant_change.innerText.toLowerCase() != "less than 4 in stock"){
//                         backorder_div_variant_change.remove();
//                         addtocart_div.insertAdjacentHTML('beforebegin','<div class="ibat-backorder"><span>Less than 4 In Stock</span></div>');
//                         if(selection_div_for_padd_change.classList.contains('ibat-without-backorder')){
//                           selection_div_for_padd_change.classList.remove('ibat-without-backorder');
//                         }
//                       }
//                     }
//                     else {
//                       if(backorder_div_variant_change){
//                         backorder_div_variant_change.remove();
//                         if(!selection_div_for_padd_change.classList.contains('ibat-without-backorder')){
//                           selection_div_for_padd_change.classList.add('ibat-without-backorder');
//                         }
//                       }
//                     }
//                   }
//                 });
//               }
            
//           })
//           .catch(error => {
//             console.error("Error fetching product details:", error);
//           });
//           start_url = change_url;
//         }
//       }, 800);
//     });
//   });
// // });




(() => {
  const EXCLUDED_PRODUCT_IDS = [
    "7314112905304",
    "7311853027416",
    "4492776833112"
  ];

  const BACKORDER_TEXT = "Backorder: Ships Once In Stock";

  let productData = null;
  let loadedProductUrl = "";
  let loadingProductUrl = "";
  let retryTimers = [];

  let initialObserver = null;
  let observerTimer = null;
  let observerStopTimer = null;

  /*
   * Get current product .js URL
   */
  function getProductUrl() {
    const path = window.location.pathname.replace(/\/$/, "");
    return `${path}.js`;
  }

  /*
   * Get variant by ID
   */
  function getVariantById(variantId) {
    if (!variantId || !productData?.variants) {
      return null;
    }

    return (
      productData.variants.find(
        (variant) =>
          String(variant.id) === String(variantId)
      ) || null
    );
  }

  /*
   * Get the ACTUAL selected Shopify variant.
   *
   * Priority:
   * 1. Shopify product form variant ID
   * 2. URL ?variant=
   * 3. Custom picker fallback
   */
  function getSelectedVariant() {
    if (!productData?.variants?.length) {
      return null;
    }

    /*
     * 1. Shopify product form
     *
     * This represents the complete
     * Color + Length + other option combination.
     */
    const variantInput = document.querySelector(
      'form[action*="/cart/add"] [name="id"], form [name="id"]'
    );

    if (variantInput?.value) {
      const variant = getVariantById(
        variantInput.value
      );

      if (variant) {
        return variant;
      }
    }

    /*
     * 2. URL variant
     */
    const urlVariantId = new URLSearchParams(
      window.location.search
    ).get("variant");

    if (urlVariantId) {
      const variant = getVariantById(
        urlVariantId
      );

      if (variant) {
        return variant;
      }
    }

    /*
     * 3. Custom picker fallback
     *
     * Only used if Shopify form/URL
     * has not provided the variant yet.
     */
    const checkedInputs = document.querySelectorAll(
      ".ib-custom-product-variant-picker-color-swatch__input:checked, " +
      ".ib-prod-variant input:checked"
    );

    for (const input of checkedInputs) {
      let variant = getVariantById(
        input.dataset.variantId
      );

      if (!variant) {
        variant = getVariantById(
          input.value
        );
      }

      if (variant) {
        return variant;
      }
    }

    /*
     * Do not guess a variant.
     */
    return null;
  }

  /*
   * Get Add to Cart wrapper
   */
  function getAddToCartElement() {
    return document.querySelector(
      ".add-to-cart-wrapper"
    );
  }

  /*
   * Get selection element
   */
  function getSelectionElement() {
    return document.querySelector(
      ".ibat-your-selection"
    );
  }

  /*
   * Remove all Backorder / Low Stock notices
   */
  function removeAllNotices() {
    document
      .querySelectorAll(".ibat-backorder")
      .forEach((notice) => {
        notice.remove();
      });
  }

  /*
   * Update spacing around selection area
   */
  function updateSelectionSpacing(showNotice) {
    const selection =
      getSelectionElement();

    if (!selection) {
      return;
    }

    selection.classList.toggle(
      "ibat-without-backorder",
      !showNotice
    );
  }

  /*
   * Update "Backorder" label
   * under individual Length options.
   */
  function updatePickerBackorderLabels() {
    if (!productData) {
      return;
    }

    const fieldsets =
      document.querySelectorAll(
        ".ib-custom-product-variant-picker-color-swatch__fieldset"
      );

    fieldsets.forEach((fieldset) => {
      const legend =
        fieldset.querySelector(
          ".ib-custom-product-variant-picker-color-swatch__legend"
        );

      const isLengthFieldset =
        legend &&
        legend.textContent
          .toLowerCase()
          .includes("length");

      const options =
        fieldset.querySelectorAll(
          ".ib-custom-product-variant-picker-color-swatch__option"
        );

      /*
       * Only process Length.
       */
      if (
        !isLengthFieldset ||
        EXCLUDED_PRODUCT_IDS.includes(
          String(productData.id)
        )
      ) {
        options.forEach((option) => {
          option.classList.remove(
            "is-backorder"
          );
        });

        return;
      }

      options.forEach((option) => {
        const input =
          option.querySelector(
            ".ib-custom-product-variant-picker-color-swatch__input"
          );

        if (!input) {
          return;
        }

        const variant =
          getVariantById(
            input.dataset.variantId
          );

        if (!variant) {
          option.classList.remove(
            "is-backorder"
          );

          return;
        }

        const quantity = Number(
          variant.inventory_quantity
        );

        option.classList.toggle(
          "is-backorder",
          quantity <= 0
        );
      });
    });
  }

  /*
   * Create / update main notice
   */
  function placeNotice(
    message,
    addToCart
  ) {
    if (
      !addToCart ||
      !addToCart.parentNode
    ) {
      return;
    }

    const previousElement =
      addToCart.previousElementSibling;

    /*
     * Notice already correct.
     */
    if (
      previousElement?.classList.contains(
        "ibat-backorder"
      ) &&
      previousElement.textContent.trim() ===
        message
    ) {
      /*
       * Remove duplicate notices.
       */
      document
        .querySelectorAll(
          ".ibat-backorder"
        )
        .forEach((notice) => {
          if (
            notice !== previousElement
          ) {
            notice.remove();
          }
        });

      return;
    }

    /*
     * Remove old notice.
     */
    removeAllNotices();

    /*
     * Create new notice.
     */
    const notice =
      document.createElement("div");

    notice.className =
      "ibat-backorder";

    const span =
      document.createElement("span");

    span.textContent = message;

    notice.appendChild(span);

    /*
     * Insert immediately before
     * Add to Cart.
     */
    addToCart.parentNode.insertBefore(
      notice,
      addToCart
    );
  }

  /*
   * Main Backorder logic
   */
  function renderNotice() {
    if (!productData) {
      return false;
    }

    /*
     * Update Length labels.
     */
    updatePickerBackorderLabels();

    const addToCart =
      getAddToCartElement();

    /*
     * Product area isn't ready yet.
     */
    if (
      !addToCart ||
      !addToCart.parentNode
    ) {
      return false;
    }

    /*
     * Excluded products.
     */
    if (
      EXCLUDED_PRODUCT_IDS.includes(
        String(productData.id)
      )
    ) {
      removeAllNotices();
      updateSelectionSpacing(false);

      return true;
    }

    /*
     * Get selected variant.
     */
    const selectedVariant =
      getSelectedVariant();

    /*
     * Shopify hasn't finished
     * initializing the variant.
     */
    if (!selectedVariant) {
      return false;
    }

    const quantity = Number(
      selectedVariant.inventory_quantity
    );

    let message = "";

    /*
     * Quantity <= 0
     * → Backorder
     */
    if (quantity <= 0) {
      message =
        BACKORDER_TEXT;
    }

    /*
     * Quantity 1–4
     * → Low stock
     */
    

    /*
     * Quantity > 4
     * → No message
     */
    if (!message) {
      removeAllNotices();
      updateSelectionSpacing(false);

      return true;
    }

    /*
     * Show notice.
     */
    placeNotice(
      message,
      addToCart
    );

    updateSelectionSpacing(true);

    return true;
  }

  /*
   * Clear retry timers
   */
  function clearRetryTimers() {
    retryTimers.forEach(
      (timer) => {
        window.clearTimeout(timer);
      }
    );

    retryTimers = [];
  }

  /*
   * Initial checks
   *
   * Reduced from:
   * 0,150,300,500,800,1200,1800,2500
   *
   * To:
   * 0,200,500,1000
   */
  function scheduleInitialChecks() {
    clearRetryTimers();

    [
      0,
      200,
      500,
      1000
    ].forEach((delay) => {
      const timer =
        window.setTimeout(() => {
          renderNotice();
        }, delay);

      retryTimers.push(timer);
    });
  }

  /*
   * Initial product-area observer
   *
   * IMPORTANT:
   * We only observe the product area.
   * We do NOT observe the whole document.
   */
  function startInitialObserver() {
    if (initialObserver) {
      return;
    }

    const productArea =
      document.querySelector(
        "#product-right"
      ) ||
      document.querySelector(
        ".product-section"
      ) ||
      document.querySelector(
        ".product"
      );

    if (!productArea) {
      return;
    }

    initialObserver =
      new MutationObserver(() => {
        /*
         * Debounce DOM mutations.
         */
        clearTimeout(
          observerTimer
        );

        observerTimer =
          window.setTimeout(() => {
            renderNotice();
          }, 100);
      });

    initialObserver.observe(
      productArea,
      {
        childList: true,
        subtree: true
      }
    );

    /*
     * Stop observer after 1.5 seconds.
     *
     * This is reduced from 3 seconds
     * to improve initial performance.
     */
    observerStopTimer =
      window.setTimeout(() => {
        if (initialObserver) {
          initialObserver.disconnect();
          initialObserver = null;
        }

        clearTimeout(
          observerTimer
        );

        observerTimer = null;
        observerStopTimer = null;

      }, 1500);
  }

  /*
   * Variant changes
   */
  function refreshAfterVariantChange() {
    clearRetryTimers();

    /*
     * Short retry window after
     * variant selection.
     */
    [
      100,
      300,
      600,
      900
    ].forEach((delay) => {
      const timer =
        window.setTimeout(() => {
          checkCurrentProduct();
        }, delay);

      retryTimers.push(timer);
    });
  }

  /*
   * Load product JSON
   */
  async function loadProductData() {
    const productUrl =
      getProductUrl();

    /*
     * Already loaded.
     */
    if (
      productData &&
      loadedProductUrl ===
        productUrl
    ) {
      scheduleInitialChecks();
      return;
    }

    /*
     * Prevent duplicate requests.
     */
    if (
      loadingProductUrl ===
      productUrl
    ) {
      return;
    }

    loadingProductUrl =
      productUrl;

    try {
      const response =
        await fetch(productUrl);

      if (!response.ok) {
        throw new Error(
          `Product JSON request failed: ${response.status}`
        );
      }

      const data =
        await response.json();

      /*
       * Product changed while
       * request was running.
       */
      if (
        productUrl !==
        getProductUrl()
      ) {
        return;
      }

      productData = data;

      loadedProductUrl =
        productUrl;

      /*
       * Update Length labels.
       */
      updatePickerBackorderLabels();

      /*
       * Start short initial observer.
       */
      startInitialObserver();

      /*
       * Initial checks.
       */
      scheduleInitialChecks();

    } catch (error) {
      console.error(
        "Backorder notice: error fetching product details:",
        error
      );

    } finally {
      if (
        loadingProductUrl ===
        productUrl
      ) {
        loadingProductUrl =
          "";
      }

      /*
       * If URL changed while fetching,
       * load new product.
       */
      if (
        getProductUrl() !==
        loadedProductUrl
      ) {
        loadProductData();
      }
    }
  }

  /*
   * Check current product
   */
  function checkCurrentProduct() {
    /*
     * Product changed.
     */
    if (
      getProductUrl() !==
      loadedProductUrl
    ) {
      loadProductData();
      return;
    }

    renderNotice();
  }

  /*
   * Change event
   *
   * Delegated listener so it still
   * works if Shopify replaces picker HTML.
   */
  document.addEventListener(
    "change",
    (event) => {
      if (
        event.target.matches(
          ".ib-custom-product-variant-picker-color-swatch__input, " +
          ".ib-prod-variant input, " +
          'form[action*="/cart/add"] [name="id"], ' +
          'form [name="id"]'
        )
      ) {
        refreshAfterVariantChange();
      }
    }
  );

  /*
   * Click event
   */
  document.addEventListener(
    "click",
    (event) => {
      if (
        event.target.closest(
          ".ib-custom-product-variant-picker-color-swatch__option, " +
          ".ib-prod-variant"
        )
      ) {
        refreshAfterVariantChange();
      }
    }
  );

  /*
   * Browser back / forward
   */
  window.addEventListener(
    "popstate",
    refreshAfterVariantChange
  );

  /*
   * Start
   */
  function start() {
    /*
     * Start short product-area observer.
     */
    startInitialObserver();

    /*
     * Load product JSON.
     */
    loadProductData();
  }

  /*
   * DOM ready
   */
  if (
    document.readyState ===
    "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      start,
      { once: true }
    );
  } else {
    start();
  }
})();